const _ = require('lodash');
const { getObjectValue, paramString } = require('@root/helpers');

module.exports = {
	getRecipients: _.debounce(({ commit }, payload) => {
		axios.get('/api/messages/recipients').then(({ data }) => {
			commit(
				'SET_VALUE',
				{
					name: 'messages.recipients',
					value: data,
				},
				{ root: true }
			);
		});
	}, 500),

	getMessages({ commit, dispatch }, payload) {
		return dispatch('GET_MESSAGES', payload).then(({ data }) => {
			commit(
				'SET_VALUE',
				{
					name: 'messages.messages',
					value: data,
				},
				{ root: true }
			);

			return data;
		});
	},

	getSentMessages({ commit, dispatch }, payload) {
		return dispatch('GET_MESSAGES', payload).then(({ data }) => {
			commit(
				'SET_VALUE',
				{
					name: 'messages.sent_messages',
					value: data,
				},
				{ root: true }
			);

			return data;
		});
	},

	GET_MESSAGES({ dispatch }, payload) {
		return dispatch(
			'ajaxRequest',
			{
				url: '/api/messages',
				params: payload,
			},
			{ root: true }
		);
	},

	postMessage({ dispatch, commit }, payload) {
		return dispatch(
			'ajaxRequest',
			{
				method: 'post',
				url: '/api/messages',
				data: payload,
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			},
			{ root: true }
		).then(({ data }) => {
			// console.log(data.message);
			let date = Date.now();

			commit(
				'ADD_NOTIFICATION',
				{
					show: true,
					type: 'success',
					text: 'Message has been sent.',
					id: `message-${data.message.id}-sent-${date}`,
				},
				{ root: true }
			);

			commit('ADD_SENT_MESSAGE', data.message);

			return data;
		});
	},

	//TODO refactor to combine this and the previous method
	postAlert({ commit }, payload) {
		return axios
			.post('/api/alerts', payload, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then(({ data }) => {
				let date = Date.now();
				// console.log(data.message);

				commit(
					'ADD_NOTIFICATION',
					{
						show: true,
						type: 'success',
						text: 'Alert has been sent.',
						id: `alert-${data.message.id}-sent-${date}`,
					},
					{ root: true }
				);

				// commit('ADD_SENT_MESSAGE', data.message);

				return data;
			});
	},

	changeStatus({ commit, state }, payload) {
		axios
			.post(`/api/messages/${payload.id}/${payload.status}`)
			.then(({ data }) => {
				let index = _.findIndex(state.messages, {
					id: data.message_id,
				});

				let field = '';

				if (payload.status === 'read' || payload.status === 'unread') {
					field = 'read_at';
				} else {
					field = 'archived_at';

					if (
						getObjectValue(
							`messages.${index}.pivot.${field}`,
							state,
							undefined
						) === null
					) {
						commit(
							'SET_VALUE',
							{
								name: `messages.messages.${index}.pivot.read_at`,
								value: data.timestamp,
							},
							{ root: true }
						);
					}
				}

				commit(
					'SET_VALUE',
					{
						name: `messages.messages.${index}.pivot.${field}`,
						value: data.timestamp,
					},
					{ root: true }
				);
			});
	},
};
